import { Fragment } from 'react'
import { Box, Flex, Grid as ThemeUIGrid } from 'theme-ui'

import Type from 'src/components/gel/Type'
import GridCard from 'src/components/card/GridCard'

export interface GridCard {
  title: string
  image: { src: string; alt: string }
  url: string
  filterCategories: string[]
}

export interface GridProps {
  title: string
  cards: GridCard[]
  styleOptions?: {
    addBottomBorder: boolean
  }
}

const Grid = ({ title, cards, styleOptions }: GridProps) => {
  return (
    <Box variant="layout.wideContainer" sx={{ px: [4] }}>
      <Flex
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          pt: [10],
          pb: [4]
        }}
      >
        <Type variant="SectionTitleSerif" sx={{ color: 'text.primary' }}>
          {title}
        </Type>
      </Flex>
      <ThemeUIGrid gap={4} columns={[1, 1, 2, 2, 3]}>
        {cards.map((card, idx) => (
          <Fragment key={`${idx}-${card.title}`}>
            <Box sx={{ mb: [4], pt: [4] }} key={card.title}>
              <GridCard image={card.image} title={card.title} link={card.url} />
            </Box>
          </Fragment>
        ))}
      </ThemeUIGrid>
      {styleOptions && styleOptions.addBottomBorder ? (
        <Box as="hr" sx={{ border: 'secondaryThin', mb: [4] }} />
      ) : null}
    </Box>
  )
}

export default Grid
